import React from 'react';
import { BLOCKING_REASON_TYPES } from '@24i/nxg-sdk-photon';
import { defaultIconStyle } from './styled';
import { StyledIcon as PlayerIcon } from '../../../../Icons';
export const BlockingMessageIcon = ({ blockingReason, style = defaultIconStyle, }) => {
    switch (blockingReason) {
        case BLOCKING_REASON_TYPES.GEO_TYPE:
            return React.createElement(PlayerIcon, { name: "onDark-geoblocked", style });
        default:
            return null;
    }
};
//# sourceMappingURL=index.js.map